






































































































































































































































































import { Component, Prop, Vue, Watch, Provide } from "vue-property-decorator";
import { IRoom, IRoomControl, IRoomStaff } from "@/@types/hotel/room";

import { validationMixin } from "vuelidate";
import { required, numeric } from "vuelidate/lib/validators";
import { VueEditor } from "vue2-editor";
import { IActivityStatus as ITV } from "@/@types/admin/activity-status";
import { IStaff } from "@/@types/admin/staff";

import SubmitResetButtonGroop from "@/components/buttons/submit-reset-button-groop.vue";
import StandartCategoryDd from "@/components/app/dropdowns/standart-category-dd.vue";
import BSwitch from "../../app/switchs/b-switch.vue";
import InputSearch from "@/components/app/search/input-search.vue";
import StaffForm from "@/components/forms/staff/staff-form.vue";
import UploadPicture from "@/components/app/images/upload-picture.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({
  mixins: [validationMixin],
  validations: {
    name: { required },
    area: { numeric },
  },
  components: {
    StandartModal,
    BSwitch,
    VueEditor,
    onsubmit: SubmitResetButtonGroop,
    StandartCategoryDd,
    InputSearch,
    StaffForm,
    UploadPicture,
  },
})
export default class RoomlForm extends Vue {
  @Provide("staffPhoto") staffPhoto = "hotel_info/staff";
  @Prop({ type: Object, default: null }) el!: IRoom;
  @Prop({ type: Array, default: () => [] }) types!: Array<IRoomControl>;
  @Prop({ type: Array, default: () => [] }) levels!: Array<IRoomControl>;
  @Prop({ type: Array, default: () => [] }) statuses!: Array<IRoomControl>;
  @Prop({ type: Array, default: () => [] }) tvs!: Array<ITV>;
  @Prop({ type: Array, default: () => [] }) devices!: Array<ITV>;
  @Prop({ type: Array, default: () => [] }) staffs!: Array<IStaff>;
  @Prop({ type: String, default: "" }) islevel!: string;

  locale = this.$store.getters.getLanguages[0];

  name = "";
  show = true;
  type = "";
  level = "";
  status = "";
  area = 0;
  smart_home_id = "";
  tv_list: Array<string> = [];
  device_list: Array<string> = [];
  staff_list: Array<IRoomStaff> = [];
  main_photo = "";
  room_plan = "";
  fire_plan = "";
  other_photo: Array<string> = [];

  searchStaff = "";
  searchTVs = "";
  searchDevices = "";

  get item(): Partial<IRoom> {
    return {
      _id: this.el ? this.el._id : "",
      name: this.name,
      show: this.show,
      type: this.type,
      level: this.level,
      status: this.status,
      area: this.area,
      smart_home_id: this.smart_home_id,
      tvs: this.tv_list,
      devices: this.device_list,
      staff: this.staff_list,
      src: {
        main_photo: this.main_photo,
        room_plan: this.room_plan,
        fire_plan: this.fire_plan,
        other_photo: this.other_photo,
      },
    };
  }

  get staffFull(): Array<IStaff> {
    return this.staffs.filter((item) => {
      if (item.name)
        return (
          this.$getLocale(item.name)
            .toLowerCase()
            .indexOf(this.searchStaff.toLowerCase()) > -1
        );
    });
  }

  get tvsFull(): Array<ITV> {
    return this.tvs.filter((item) => {
      if (item.tv_name) {
        return (
          item.tv_name.toLowerCase().indexOf(this.searchTVs.toLowerCase()) > -1
        );
      } else {
        if (item.room_number) {
          console.log("item.room_number");
          return (
            item.room_number
              .toLowerCase()
              .indexOf(this.searchTVs.toLowerCase()) > -1
          );
        }
      }
    });
  }

  get devicesFull(): Array<ITV> {
    return this.devices.filter((item) => {
      if (item.tv_name) {
        return (
          item.tv_name.toLowerCase().indexOf(this.searchDevices.toLowerCase()) >
          -1
        );
      } else {
        if (item.room_number) {
          return (
            item.room_number
              .toLowerCase()
              .indexOf(this.searchDevices.toLowerCase()) > -1
          );
        }
      }
    });
  }

  autoGetTV(): void {
    this.autoFind(this.tvs, this.tv_list);
    this.autoFind(this.devices, this.device_list);
  }

  autoFind(list: Array<ITV>, selected: Array<string>): void {
    const byName = list.find((t) => t.tv_name == this.name);
    const byRoom = list.find((t) => t.room_number == this.name);
    const id = byName ? byName._id : byRoom ? byRoom._id : undefined;
    if (id && !selected.includes(id)) selected.push(id);
  }

  @Watch("area")
  setArea(): void {
    sessionStorage.setItem("room-area", String(this.area));
  }

  @Watch("type")
  setType(): void {
    sessionStorage.setItem("room-type", String(this.type));
  }

  getTVName(id: string): string {
    const tv = this.tvs.find((el) => el._id == id);
    const name = tv && tv.tv_name ? tv.tv_name : tv ? tv.room_number : "";
    return name ? name : id;
  }

  addTV(id: string | undefined): void {
    if (id && !this.tv_list.includes(id)) this.tv_list.push(id);
  }

  getDeviceName(id: string): string {
    const device = this.devices.find((el) => el._id == id);
    const name =
      device && device.tv_name
        ? device.tv_name
        : device
        ? device.room_number
        : "";
    return name ? name : id;
  }

  addDevice(id: string | undefined): void {
    if (id && !this.device_list.includes(id)) this.device_list.push(id);
  }

  addStaff(persone: IStaff): void {
    this.staff_list.forEach((el) => {
      if (el.staff_id == persone._id) return;
    });
    this.staff_list.push({
      _id: "",
      staff_id: persone._id,
      role: persone.post,
      name: persone.name,
    });
  }

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    if (this.$v.$invalid) {
      this.$v.$touch();
      return;
    }

    this.$emit("change", this.item, this.item._id);
  }

  onReset(): void {
    this.show = false;
    this.name = "";
    this.type = "";
    this.level = "";
    this.status = "";
    this.area = 0;
    this.smart_home_id = "";
    this.tv_list = [];
    this.device_list = [];
    this.staff_list = [];
    this.main_photo = "";
    this.room_plan = "";
    this.fire_plan = "";
    this.other_photo = [];
    this.locale = this.$store.getters.getLanguages[0];
  }

  @Watch("level")
  onLevel(): void {
    this.$emit("changeLevel", this.level);
  }

  @Watch("el")
  autoFillingForm(): void {
    if (!this.el) return;
    this.name = this.el.name ? this.el.name : "";
    this.show = this.el.show ? this.el.show : false;
    this.type = this.el.type ? this.el.type : "";
    this.level = this.el.level ? this.el.level : "";
    this.status = this.el.status ? this.el.status : "";
    this.area = this.el.area ? this.el.area : 0;
    this.smart_home_id = this.el.smart_home_id ? this.el.smart_home_id : "";
    this.tv_list = this.el.tvs ? this.el.tvs : [];
    this.device_list = this.el.devices ? this.el.devices : [];
    this.staff_list = this.el.staff ? this.el.staff : [];
    this.main_photo = this.el.src ? this.el.src.main_photo : "";
    this.room_plan = this.el.src ? this.el.src.room_plan : "";
    this.fire_plan = this.el.src ? this.el.src.fire_plan : "";
    this.other_photo = this.el.src ? this.el.src.other_photo : [];
  }

  lazyPadding(): void {
    const area = sessionStorage.getItem("room-area");
    this.area = area ? parseInt(area) : 0;
    const type = sessionStorage.getItem("room-type");
    this.type = type ? type : "";
  }

  mounted(): void {
    this.level = this.islevel;
    this.lazyPadding();
    if (this.el) this.autoFillingForm();
  }
}
